module.exports = "/_next/static/media/e22c65d3caf68bac54d4be101ea4b792.svg";